/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-external-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
// External Imports
import config from '@linc-technologies/linced-common/utils/config';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class ChangePassword extends Component {
  // Constants
  learnerPasswordMinLength = 6;
  defaultPasswordMinLength = 14;
  class = '';

  // Services
  @service
  session;

  @service
  permissions;

  @service
  toaster;

  // State
  @tracked
  passwordValidationError = '';

  @tracked
  hasError = false;

  @tracked
  passwordSaving = false;

  @tracked
  oldPassword = '';

  @action
  setOldPassword(value) {
    this.oldPassword = value;
  }

  @tracked
  newPassword = '';

  @tracked
  confirmPassword = '';

  @action
  setConfirmPassword(value) {
    this.confirmPassword = value;
  }

  @tracked
  code = '';

  @action
  setCode(value) {
    this.code = value;
  }

  @computed('session.scopes.[]')
  get minLength() {
    if (this.permissions.equal('urn:linced:organisation:role:learner')) {
      return this.learnerPasswordMinLength;
    }
    return this.defaultPasswordMinLength;
  }

  async doUpdatePasswordRequest(uri, opts) {
    try {
      const response = await fetch(uri, opts);

      if (!response.ok) {
        const responseJson = await response.json();
        let details = responseJson.message;

        // Reset/clear error and fields
        this.passwordValidationError = `Error changing password. ${details}`;
        this.hasError = true;
        this.oldPassword = '';
        this.code = '';
        this.passwordSaving = false;
        return;
      }

      this.passwordValidationError = '';
      this.hasError = false;
      this.passwordSaving = false;
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.code = '';

      this.toaster.success('Your password was successfully updated!');
    } catch (err) {
      this.toaster.error(err);
    }
  }

  @action
  noop() {}

  @action
  onChangeNewPassword(value) {
    this.newPassword = value;
    this.passwordValidationError = '';
  }

  @action
  async changePassword() {
    let newPassword = this.newPassword;
    let confirmPassword = this.confirmPassword;

    if (newPassword !== confirmPassword || newPassword.length === 0) {
      this.toaster.error("Oops! Your new password doesn't seem to match.");
      this.confirmPassword = '';
      return;
    }
    this.passwordSaving = true;

    let data = {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
      code: this.code,
    };

    const tokenWrapper = await this.session.getToken();
    let options = {
      body: JSON.stringify(data),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenWrapper.token}`,
      },
    };
    await this.doUpdatePasswordRequest(
      `${config.APP.apiHost}/auth/v4/users/me/:password`,
      options,
    );
  }
}
